import { px, aRect, mPx } from '../../../pixel/canvas';
import { SLOT } from '../slots';
import type { Part } from '../../types';

export const muzzles: Record<string, Part> = {
  muzzle_flash: {
    id: 'muzzle_flash',
    category: 'muzzle',
    name: 'Flash',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.accent); mPx(ctx, 1, a.y, p.accentDark); aRect(ctx, a.x, a.y - 1, 2, 1, p.exhaustHot); },
  },
  muzzle_collector: {
    id: 'muzzle_collector',
    category: 'muzzle',
    name: 'Collector',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.metal); aRect(ctx, a.x, a.y - 1, 2, 1, p.accent); },
  },
  muzzle_suppressor: {
    id: 'muzzle_suppressor',
    category: 'muzzle',
    name: 'Suppressor',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 1, 2, 4, p.metalDark); aRect(ctx, a.x, a.y - 1, 2, 1, p.metal); },
  },
  muzzle_flame: {
    id: 'muzzle_flame',
    category: 'muzzle',
    name: 'Flame',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.exhaustHot); aRect(ctx, a.x, a.y - 1, 2, 1, p.exhaust); aRect(ctx, a.x, a.y - 2, 2, 1, p.exhaustCool); mPx(ctx, 1, a.y - 1, p.exhaust); },
  },
  muzzle_ring: {
    id: 'muzzle_ring',
    category: 'muzzle',
    name: 'Plasma Ring',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.accent); mPx(ctx, 1, a.y - 1, p.accentLight); aRect(ctx, a.x, a.y - 1, 2, 1, p.accent); },
  },
  muzzle_vent: {
    id: 'muzzle_vent',
    category: 'muzzle',
    name: 'Double Vent',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { mPx(ctx, 1, a.y, p.metalDark); mPx(ctx, 2, a.y - 1, p.metalDark); mPx(ctx, 1, a.y - 1, p.exhaustHot); },
  },
  muzzle_scope: {
    id: 'muzzle_scope',
    category: 'muzzle',
    name: 'Scope',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 1, p.metalDark); aRect(ctx, a.x, a.y - 1, 4, 1, p.metalDark); aRect(ctx, a.x, a.y - 2, 4, 1, p.metal); aRect(ctx, a.x, a.y - 1, 2, 1, p.glass); },
  },
  muzzle_fork: {
    id: 'muzzle_fork',
    category: 'muzzle',
    name: 'Fork',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 2, 2, p.metalDark); px(ctx, a.x - 2, a.y - 1, p.metal); px(ctx, a.x + 1, a.y - 1, p.metal); px(ctx, a.x - 2, a.y - 2, p.accent); px(ctx, a.x + 1, a.y - 2, p.accent); },
  },
  muzzle_coil: {
    id: 'muzzle_coil',
    category: 'muzzle',
    name: 'Coil',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y - 2, 4, 4, p.metalDark); aRect(ctx, a.x, a.y - 1, 2, 2, p.accent); aRect(ctx, a.x, a.y - 2, 2, 1, p.accentLight); },
  },
  muzzle_crown: {
    id: 'muzzle_crown',
    category: 'muzzle',
    name: 'Crown',
    requires: SLOT.MUZZLE_TOP,
    draw: (ctx, a, p) => { aRect(ctx, a.x, a.y, 4, 1, p.metal); px(ctx, a.x - 2, a.y - 1, p.metalDark); px(ctx, a.x + 1, a.y - 1, p.metalDark); px(ctx, a.x - 1, a.y - 2, p.accent); px(ctx, a.x, a.y - 2, p.accent); px(ctx, a.x - 2, a.y - 2, p.metalLight); px(ctx, a.x + 1, a.y - 2, p.metalLight); },
  },
};
